import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('smoke_check', '/smoke_checks')
const actions = generator.generate()

export default actions
